import React from "react";
import {Link} from "react-router-dom";

function Footer(){
    return (

        <>
        <footer class="bg-white dark:bg-brunswick-600">
        <div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
            <div class="md:flex md:justify-between">
            <div class="mb-6 md:mb-0">
                <a href="https://macanista.com/" class="flex items-center">
                    <img src={require("../../../assets/img/logos/Logo.png")} class="h-10 me-3" alt="Macanista Logo" />

                    <img src={require("../../../assets/img/logos/Logowhite_text.png")} class="h-10 me-3" alt="Macanista Logo" />
                </a>
            </div>
            <div class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
                <div>
                    <h2 class="mb-6 text-sm font-semibold text-gray-600 uppercase dark:text-white">Navigation</h2>
                    <ul class="text-gray-500 dark:text-gray-400 font-medium">
                        <li class="mb-4">
                            <Link to="/about" class="hover:underline">Company Info</Link>
                        </li>
                        <li class="mb-4">
                            <Link to="/Products" class="hover:underline">Products</Link>
                        </li>
                        <li>
                            <Link to="/Resources" class="hover:underline">Resources</Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Follow us</h2>
                    <ul class="text-gray-500 dark:text-gray-400 font-medium">
                        <li class="mb-4">
                            <a href="https://www.linkedin.com/in/macanista-robotics-949904347/" class="hover:underline ">LinkedIn</a>
                        </li>
                        <li class="mb-4">
                            <a href="https://www.instagram.com/macanista.robotics/?utm_source=ig_web_button_share_sheet" class="hover:underline">Instagram</a>
                        </li>
                        <li>
                            <a href="https://www.tiktok.com/@macanista_robotics" class="hover:underline">TikTok</a>
                        </li>
                    </ul>
                </div>
                <div>
                    <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Legal</h2>
                    <ul class="text-gray-500 dark:text-gray-400 font-medium">
                        <li class="mb-4">
                            <Link to="/ethics" class="hover:underline">Ethics Statement</Link>
                        </li>
                        <li>
                            <Link to="/privacy" class="hover:underline">Privacy Policy</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <hr class="my-6 border-bone-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <div class="sm:flex sm:items-center sm:justify-between">
            <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2024 <a href="https://macanista.com/" class="hover:underline">Macanista™</a>. All Rights Reserved.
            </span>
            <div class="flex mt-4 sm:justify-center sm:mt-0 gap-3">

                <a href="https://www.instagram.com/macanista.robotics/?utm_source=ig_web_button_share_sheet" class="text-gray-500 hover:text-gray-900 dark:hover:text-white ms-5">
                    <span class="[&>svg]:h-5 [&>svg]:w-5 [&>svg]:fill-gray-500  [&>svg]:hover:fill-white">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path
                        d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                    </svg>
                    </span>
                    </a>
                    <a href="https://www.linkedin.com/in/macanista-robotics-949904347/">
                    <span class="[&>svg]:h-5 [&>svg]:w-5 [&>svg]:fill-gray-500  [&>svg]:hover:fill-white">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path
                        d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" />
                    </svg>
                    </span>
                    </a>
                    <a href="https://www.tiktok.com/@macanista_robotics">
                    <span class="[&>svg]:h-5 [&>svg]:w-5 [&>svg]:fill-gray-500  [&>svg]:hover:fill-white ">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 448 512">
                        <path
                        d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z" />
                    </svg>
                    </span>
                    </a>

            </div>
        </div>
        </div>
        </footer>
        </>
    );
};

export default Footer;